export default __webpack_public_path__ + "static/media/librix-logo.6d6f5290.png";